/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlaylist = createReactComponent("outline", "playlist", "IconPlaylist", [["path", { "d": "M14 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17 17v-13h4", "key": "svg-1" }], ["path", { "d": "M13 5h-10", "key": "svg-2" }], ["path", { "d": "M3 9l10 0", "key": "svg-3" }], ["path", { "d": "M9 13h-6", "key": "svg-4" }]]);

export { IconPlaylist as default };
//# sourceMappingURL=IconPlaylist.mjs.map
